import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoObjectKindModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoObjectKindModel._instance == null) GeoObjectKindModel._instance = new GeoObjectKindModel(authManager);
        return GeoObjectKindModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-object-kinds', 'model-sections/geo-object-kinds/codelist');

        this.entityName = 'model-sections.GeoObjectKind';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Object Kind';
        this.setLabel = 'Object Kinds';

        this.browser = {
            name: 'default-model-sections-geoobjectkind-browser',
            moduleName: 'default-model-sections-geoobjectkind-browser',
            moduleTitle: 'Object Kinds',
            moduleStateSlotName: 'default-model-sections-geoobjectkind-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoobjectkind-editor',
            moduleName: 'default-model-sections-geoobjectkind-editor',
            moduleTitle: 'Object Kind',
            moduleStateSlotName: 'default-model-sections-geoobjectkind-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
